import { Grid } from '@material-ui/core'
import Input from 'Components/Input'
import Select from 'Components/Select'
import User from 'EurestoClass/User'
import DefaultUpload from 'EurestoComponents/Upload/DefaultUpload'
import Constants from 'EurestoFonction/Constants'
import Utils from 'EurestoFonction/Utils'
import React, { useEffect, useRef, useState } from 'react'

export default React.memo((props) => {
    console.log("props in form", props)
    const object = useRef(props.object)
    const [key, setKey] = useState(Utils.getRandomNumber())

    useEffect(() => {
        if (!_.isEqual(props.object, object)) {
            object.current = props.object
            setKey(Utils.getRandomNumber())
        }
    }, [props.object])

    const catchedUploadFile = (file, base64) => {
        object.current.base64 = base64
        object.current.type_fichier = file.type
        object.current.extension = file.name.split('.').slice(-1)[0]
        object.current.libelle = object.current.libelle || object.current.extension && file.name.replace("." + object.current.extension, "") || file.name
        setKey(Utils.getRandomNumber())
    }

    const onChange = (data, name) => {
        object.current[name] = data
        props.onChange && props.onChange(object.current)
    }

    return object.current && <Grid key={'container_' + key} container style={{ padding: 10, margin: 0 }} direction={'column'} justify={'center'} align={'center'}>

        <Grid key={'row_picture_' + key} container style={{ padding: 10, margin: 0 }} direction={'row'} justify={'center'} align={'center'}>
            <DefaultUpload disabled={props.disabled} clickable style={{ height: 75, maxHeight: 75, width: 75, margin: '2.5px 5px 2.5px 2.5px', borderRadius: '50%' }}
                catchedUploadFile={catchedUploadFile}>
                {object.current.type_fichier && object.current.type_fichier.indexOf('image/') === -1 ?
                    <Grid key={'row_picture_icon_' + key} container style={{ padding: 10, margin: 0, height: '100%' }} direction={'column'} justify={'center'} align={'center'}>
                        <i style={{ height: 30 }} className={'ei-module_documentation fa-2x'} />
                    </Grid> : <img style={{ borderRadius: '50%' }} width={75} height={75}
                        src={object.current.id ? object.current.lien : (object.current.base64 ? `data:${object.current.type_fichier};base64,${object.current.base64}` : undefined)} alt={object.current.libelle} />}
            </DefaultUpload>
        </Grid>
        {object.current.lien && <a target="_blank" href={object.current.lien}>Lien du media</a>}
        <Input disabled={props.disabled}
            key={'input_' + key}
            title={EurestoI18n.t('commun:Nom')}
            onChange={onChange}
            name={'libelle'}
            value={object.current.libelle}
        />
        <Select title={EurestoI18n.t('crm:Type')} name="type_media_id"
            disabled={props.disabled}
            onChange={onChange}
            value={object.current.type_media_id}
            options={[...(
                (User.TypeAccess.get(Constants.access.EURESTO)) && [{
                    value: 85,
                    label: 'Version Euresto'
                }, {
                        value: 80,
                        label: 'Patch Euresto 32.042.0'
                    }, {
                        value: 81,
                        label: 'Patch Euresto 32.042.1'
                    }, {
                        value: 70,
                        label: 'Patch Mobile'
                    }] || []
            ), {
                value: 99,
                label: 'Divers'
            }, ...(
                (props.showAsEntity || !User.TypeAccess.get(Constants.access.EURESTO)) && [{
                    value: 4,
                    label: 'Archive Fiscale'
                }] || []
            )]} />
    </Grid >
})


// WEBPACK FOOTER //
// ./app/App/Module/Media/Component/Media/index.js